import React from "react";
import { Modal, Input } from "antd";
import styles from "./EditCampaignModal.module.css";

const { TextArea } = Input;

const EditCampaignModal = ({
  open,
  onClose,
  campaign,
  onChange,
  onSave,
}: {
  open: boolean;
  onClose: () => void;
  campaign: any;
  onChange: (field: string, value: string) => void;
  onSave: () => void;
}) => {
  return (
    <Modal
      open={open}
      title="Edit Campaign Template"
      onCancel={onClose}
      onOk={onSave}
      okText="Save"
    >
      <div className={styles.formGroup}>
        <label>Campaign Name</label>
        <Input
          value={campaign.campaign_name}
          onChange={(e) => onChange("campaign_name", e.target.value)}
        />
      </div>

      <div className={styles.formGroup}>
        <label>Message</label>
        <TextArea
          rows={4}
          value={campaign.leadMessage}
          onChange={(e) => onChange("leadMessage", e.target.value)}
        />
      </div>
    </Modal>
  );
};

export default EditCampaignModal;
